// SEND-142 — the mark vocabulary the editor and its three rail panels
// share. ONE declaration each: the colours, the category list, the tap
// order and the two label helpers. MOVED VERBATIM — not one colour,
// category, key or label string changed with the rail split.
export const SIDING = "#2563EB";                       // PdfOverlayEditor's siding blue
export const OPENING = "#FACC15";                      // the annotator's window yellow
export const GABLE = "#15803D";                        // the annotator's own gable green
export const DORMER = "#0EA5E9";                       // the annotator's dormer blue
// SEND-147 — THE WALL-BASE MARK. A human two-tap start line, its own colour
// so it never reads as a zone edge or a trim run.
export const WALL_BASE = "#F97316";
// SEND-150 — THE TWO TRIM LINES THE CONTRACTOR DRAWS. Their own colours so
// neither reads as an anchor: these carry LF, the anchors never do.
export const STARTER = "#E11D48";
export const FASCIA = "#4338CA";
// SEND-298a — THE GUTTER RUN. The same two-tap LINE record as fascia, so it
// needs its own colour or a gutter reads as the fascia it hangs under. Slate,
// which no other lane uses.
export const GUTTER = "#334155";
// SEND-298c — THE DOWNSPOUT LINE, drawn on the gutter step: its own colour so
// a vertical drop never reads as the gutter it hangs off. Amber-700, which no
// other lane uses. Its colour inherits the job SOFFIT / FASCIA parent.
export const DOWNSPOUT = "#B45309";
// SEND-152 — the four remaining trims, same two-tap LINE record, each with
// its own colour so no run reads as another.
export const SOFFIT = "#0D9488";
export const J_CHANNEL = "#CA8A04";
// SEND-241 (Howard ruled 2026-08-14) — COLOR BY PRODUCT ON THE PHOTO. "Four
// fixed colors, not guessed per house." The colour rides the MARK's own
// product, so the same J reads the same on every photo, and re-naming a
// selected J re-colours it. Neighbouring shades of his four words, so no run
// reads as another kind: the wall base is #F97316 orange, the outside corner
// is #DB2777 magenta and the soffit is #0D9488 teal, and none of those four
// is reused here. A J WITH NO PRODUCT KEEPS THE PLAIN J GOLD — no colour is
// invented for a mark he has not named.
export const J_TYPE_COLORS = {
  siding: "#CA8A04",                                   // gold
  soffit: "#EA580C",                                   // orange
  bb: "#C026D3",                                       // magenta
  shake: "#14B8A6",                                    // teal
};
export const OUTSIDE_CORNER = "#DB2777";
export const INSIDE_CORNER = "#7C3AED";
// SEND-230 — COIL and FINISH TRIM, same two-tap LINE record, each with its
// own colour so neither reads as another run.
export const COIL = "#B91C1C";
export const FINISH_TRIM = "#065F46";
// SEND-286 — THE BAND BOARD, its own step and its own colour so a band never
// reads as a fascia, a starter or a drawn coil line.
export const BAND_BOARD = "#0E7490";
// SEND-286 — his three widths, REQUIRED on every band mark. They are not
// names: 8" and 10" are slit from the 24" × 50' coil (100 LF / roll) and 12"
// takes its full width (50 LF / roll), so the chip decides the yield bucket.
// SEND-305 (Howard ruled 2026-06) — **FIVE SIZES NOW.** "Sizes on the walk
// today are 8", 10" and 12". They stay. Add 4" and 6"." He ruled the two new
// ones INTO THE EXISTING SLIT BUCKET, so 4" + 6" + 8" + 10" share the 100 LF
// bucket and 12" keeps its own. Still required on every mark, still nothing
// defaulted.
export const BAND_WIDTHS = [
  { key: 4, label: "4\"" },
  { key: 6, label: "6\"" },
  { key: 8, label: "8\"" },
  { key: 10, label: "10\"" },
  { key: 12, label: "12\"" },
];
// SEND-288 — WHICH COIL the band batches with. Howard: "80% of the time the
// band batches with fascia, not siding", so MATCH FASCIA is the chip the walk
// arms by default and it sends the band's feet to the SOFFIT .019 Coil, the
// same line as fascia. MATCH SIDING sends them to the ACCESSORIES .019 Coil,
// added to openings. PER MARK, never a walk-level tab — one house can carry
// both.
export const BAND_MATCHES = [
  { key: "fascia", label: "MATCH FASCIA" },
  { key: "siding", label: "MATCH SIDING" },
];
// SEND-149 — THE EAVE MARK. The frieze line, its own colour so it never reads
// as a soffit or a fascia run — neither of those is built.
export const EAVE = "#A855F7";
// The drawing gesture, carried over word for word from the annotator.
// SEND-234 (Howard ruled 2026-08-14) — THE FOUR OPENING TYPES. HIS FOUR, in
// his order, asked on the OPENINGS step AFTER the box is drawn. A type is a
// NAME on that mark: no window line, no door line, no count, no money, and J
// stays what he drew. No type is an honest state — the box stays an opening.
// SEND-235 — the list lives HERE, in the one shared mark vocabulary, so the
// canvas chips and the rail chips read the SAME declaration and cannot drift.
export const OPENING_TYPES = [
  { key: "window", label: "Window" },
  { key: "garage_door", label: "Garage door" },
  { key: "entry_door", label: "Entry door" },
  { key: "sliding_glass_door", label: "Sliding glass door" },
];
export const OPENING_TYPE_LABEL = Object.fromEntries(
  OPENING_TYPES.map((o) => [o.key, o.label]));
// SEND-242 (Howard ruled 2026-08-14) — COLOR BY PRODUCT, ON THE OPENING.
// "Four fixed colors, not guessed per house": WINDOW blue, GARAGE DOOR yellow
// — the opening yellow the box already wears — ENTRY DOOR green, SLIDING
// GLASS DOOR purple. The colour rides the MARK's own type, so the same box
// reads the same on every photo and re-naming it in the rail re-colours it.
// AN UNTYPED BOX KEEPS THE PLAIN OPENING YELLOW: no colour is invented for a
// box he has not named. Neighbouring shades of his four words, so no box
// reads as another kind — the siding zone is #2563EB, the dormer is #0EA5E9,
// the gable is #15803D and the inside corner is #7C3AED.
export const OPENING_TYPE_COLORS = {
  window: "#3B82F6",                                   // blue
  garage_door: "#FACC15",                              // yellow
  entry_door: "#22C55E",                               // green
  sliding_glass_door: "#9333EA",                       // purple
};
// SEND-241 (Howard ruled 2026-08-14) — THE J VOCABULARY, IN ONE PLACE. His
// four products in HIS order and the two sizes, declared HERE beside the J
// colours so the walk's rail chips, the marks-list chips and the row label
// all read the SAME list and cannot drift. The keys and what each one writes
// are unchanged. THERE IS NO VENTED / SOLID ON J — that was withdrawn and
// none was ever added.
export const J_TYPES = [
  { key: "siding", label: "siding J" },
  { key: "soffit", label: "soffit J" },
  { key: "bb", label: "B&B J" },
  { key: "shake", label: "shake J" },
];
export const J_SIZES = [
  { key: "3/4", label: '3/4"' },
  { key: "1/2", label: '1/2"' },
];
export const J_TYPE_LABEL = Object.fromEntries(
  J_TYPES.map((t) => [t.key, t.label]));

// SEND-272 (Howard ruled 2026-06) — SIDING J AND SOFFIT J ARE TWO LANES.
// "Split the one J-CHANNEL row into two: SIDING J (Siding + B&B + Shake) and
// SOFFIT J. Each keeps its own eye." A LANE IS READ, NEVER STORED: the mark's
// own `j_type` says which side it is on, so every J mark drawn before this
// send lands on the right row with nothing migrated and nothing rewritten.
export const SOFFIT_J_LANE = "j_channel_soffit";
export const layerKeyOf = (m) => (
  m && m.kind === "j_channel" && m.j_type === "soffit"
    ? SOFFIT_J_LANE : (m ? m.kind : null));
// The two J rows say which J they are; every other lane keeps its own words.
export const LANE_LABEL = {
  j_channel: "Siding J",
  [SOFFIT_J_LANE]: "Soffit J",
};
// The J products that live on the SIDING J step — soffit J has its own step.
export const SIDING_J_PRODUCTS = ["siding", "bb", "shake"];


export const TAP_ORDER = {
  gable: ["Tap the LEFT EAVE point of the gable.", "Tap the PEAK (ridge) point.",
    "Tap the RIGHT EAVE point to finish the triangle."],
  dormer: ["Tap the BOTTOM-LEFT corner of the dormer face.", "Tap the BOTTOM-RIGHT corner.",
    "Tap the TOP-RIGHT corner.", "Tap the TOP-LEFT corner to finish the face."],
  wall_base: ["Tap the LEFT end of the starter / wall base.",
    "Tap the RIGHT end to finish the start line."],
  eave: ["Tap the LEFT end of the eave / frieze.",
    "Tap the RIGHT end to finish the eave line."],
  // SEND-150 — the trim lines HE draws. Same two-tap gesture, and these do
  // carry feet: the run is measured as drawn at this photo's own scale.
  starter: ["Tap the LEFT end of the starter run.",
    "Tap the RIGHT end to finish the starter line."],
  fascia: ["Tap the LEFT end of the fascia run.",
    "Tap the RIGHT end to finish the fascia line."],
  // SEND-298a — the gutter run, drawn ONE LINE PER RUN: each confirmed line
  // IS one run, which is what the hanger and end-cap counts are built from.
  gutter: ["Tap the LEFT end of THIS gutter run.",
    "Tap the RIGHT end to finish the gutter line."],
  // SEND-298c — the downspout: ONE LINE PER DOWNSPOUT, drawn top to bottom.
  // Each confirmed line is 1 STICK; its feet are the label on the line.
  downspout: ["Tap the TOP of THIS downspout.",
    "Tap the BOTTOM to finish the downspout line."],
  soffit: ["Tap one end of the soffit run.",
    "Tap the OTHER end to finish the soffit line."],
  j_channel: ["Tap one end of the J-channel run.",
    "Tap the OTHER end to finish the J-channel line."],
  outside_corner: ["Tap the TOP of the outside corner.",
    "Tap the BOTTOM to finish the corner line."],
  inside_corner: ["Tap the TOP of the inside corner.",
    "Tap the BOTTOM to finish the corner line."],
  // SEND-230 — coil and finish trim, the same two-tap gesture.
  coil: ["Tap one end of the coil run.",
    "Tap the OTHER end to finish the coil line."],
  finish_trim: ["Tap one end of the finish-trim run.",
    "Tap the OTHER end to finish the finish-trim line."],
};
export const CATEGORIES = [                            // the annotator's own zone colours
  { key: "brick", name: "Brick", color: "#B45309" },
  { key: "stone", name: "Stone", color: "#57534E" },
  { key: "garage_door", name: "Garage door", color: "#FBBF24" },
  { key: "stucco", name: "Stucco", color: "#A8A29E" },
  { key: "other", name: "Other", color: "#DC2626" },
];

export const markColor = (m) => {
  if (m.kind === "siding_zone") return SIDING;
  if (m.kind === "opening") return OPENING_TYPE_COLORS[m.opening_type] || OPENING;
  if (m.kind === "gable") return GABLE;
  if (m.kind === "dormer") return DORMER;
  if (m.kind === "wall_base") return WALL_BASE;
  if (m.kind === "eave") return EAVE;
  if (m.kind === "starter") return STARTER;
  if (m.kind === "fascia") return FASCIA;
  if (m.kind === "gutter") return GUTTER;
  if (m.kind === "downspout") return DOWNSPOUT;
  if (m.kind === "soffit") return SOFFIT;
  if (m.kind === "j_channel") return J_TYPE_COLORS[m.j_type] || J_CHANNEL;
  if (m.kind === "outside_corner") return OUTSIDE_CORNER;
  if (m.kind === "inside_corner") return INSIDE_CORNER;
  if (m.kind === "coil") return COIL;
  if (m.kind === "finish_trim") return FINISH_TRIM;
  if (m.kind === "band_board") return BAND_BOARD;
  return (CATEGORIES.find((c) => c.key === m.category) || CATEGORIES[4]).color;
};
export const kindLabel = (m) => (m.kind === "siding_zone" ? "SIDING"
  : m.kind === "gable" ? "GABLE"
    : m.kind === "dormer" ? "DORMER"
      : m.kind === "opening" ? "OPENING"
        : m.kind === "wall_base" ? "WALL BASE"
          : m.kind === "eave" ? "EAVE"
            : m.kind === "starter" ? (m.starter_type === "shake"
              ? "SHAKE STARTER" : "SIDING STARTER")
              : m.kind === "fascia" ? "FASCIA"
                : m.kind === "gutter" ? "GUTTER"
                  : m.kind === "downspout" ? "DOWNSPOUT"
                    : m.kind === "soffit" ? "SOFFIT"
                  : m.kind === "j_channel" ? "J-CHANNEL"
                    : m.kind === "outside_corner" ? "OUTSIDE CORNER"
                      : m.kind === "inside_corner" ? "INSIDE CORNER"
                        : m.kind === "coil" ? "COIL"
                          : m.kind === "finish_trim" ? (
                            m.trim_type === "shake" ? "SHAKE FINISH TRIM"
                              : m.trim_type === "bb" ? "B&B FINISH TRIM"
                                : "SIDING FINISH TRIM")
                            : m.kind === "band_board"
                              // SEND-287 — A REAL MARK says whether it carries
                              // its chip; the STEP'S OWN NAME (a bare
                              // `{ kind }` with no id, used by the rail's
                              // Confirm-All copy) is just BAND BOARD. The
                              // sweep confirms the CHIPPED bands, so its
                              // sentence must not read "NO WIDTH" at them.
                              ? (m.band_width_in
                                ? `TRIM BOARD ${Number(m.band_width_in)}"${m.band_match ? ` · ${m.band_match === "fascia" ? "FASCIA" : "SIDING"}` : " · NO MATCH"}`
                                : m.id ? "TRIM BOARD · NO WIDTH"
                                  : "TRIM BOARD")
    : (CATEGORIES.find((c) => c.key === m.category)?.name || "NON-SIDING").toUpperCase());
